module.exports = __webpack_public_path__ + "img/bj.b6387659.svg";